export default {
	qita: '其他',
	chengjirenyixuanze: '乘機人已選擇，不可重複選擇',
	dingdanzhuangtai: '訂單狀態',
	daifukuan: '待付款',
	daichupiao: '出票中',
	chupiaowancheng: '出票完成',
	quxiao: '取消',
	yinhangka: '銀行卡',
	dianziqianbao: '電子錢包',
	yiwancheng: '已完成',
	weiwancheng: '未完成',
	quxiaozhong: '取消中',
	zhifuzhong: '支付中',
	chongxinxuanzezhifufangshi: '重新選擇支付方式',
	zhifuweiwancheng: '支付未完成',
	jixuzhifu: '繼續支付',
	chongxingoumai: '重新購買',
	ninhaiweiwanchengzhifu: '您還未完成支付，是否繼續支付？',
	quebaoziliao: '請確保所有資料正確',
	lianluorenziliao: '聯絡人資料',
	dianhuahaoma: '電話號碼',
	fujiafuwu: '附加服務',
	feixingchangkehaoma: '飛行常客號碼',
	dianziyouhuiquan: '電子優惠券',
	meiyoudianziyouhui: '沒有申請電子優惠券',
	wodedaima: '我有代碼',
	jiayiri: '日',
	jiaerri: '日',
	xianzaifukuan: '現在付款',
	zhifuwancheng: '支付完成',
	yudaowenti: '遇到問題',
	zhifuwanchengqianqingbuyao: '支付完成前請不要關閉此視窗',
	querenzhifu: '確認支付',
	qingninzaixindakaideyemian: '請您在新打開的頁面進行支付！',
	cuowuyuanyin: '錯誤原因',
	zhifucuowu: '支付錯誤',
	bizhongbuzhichi: '不支持該貨幣',
	jinechaochuxianzhi: '金额超过限额',
	xiugai: '修改',
	xiangqing: '详情',
	chengke: '乘客',
	daililianluoziliao: '代理聯絡資料',
	banlidengji: '辦理登機',
	chakanguanli: '查看/管理',
	chufa: '出發',
	riqishijian: '日期/時間',
	yudingcankaobianhao: '預訂參考編號',
	chengshijichang: '城市/機場',
	dao: '到',
	daoda: '到達',
	daodashijian: '到達時間',
	xingcheng: '行程',
	lieyin: '列印',
	shuikuanfapiao: '稅款發票',
	genggaihangbanyaoqiu: '更改航班要求',
	lvxingshijian: '旅行時間',
	xinglie: '行李額',
	nian: '年',
	yue: '月',
	geshibuzhengque: '格式錯誤',
	lianxirenxingming: '連絡人姓名',
	tuipiao: '退票',
	gaiqian: '改簽',
	querenyaotuipiaoma: '確認要退票嗎？',
	querenyaogaiqianma: '確認要改簽嗎？',
	pingtaifuwufei: '平臺服務費',
	xuzhifu: '需支付',
	jishufuwufei: '技術服務費',
	canshucuowu: '參數錯誤',
	chupiaoshibaichongxinyuding: '出票失敗，已退款成功，請重新預定。',
	chupiaoshibaibufentuikuanchenggong: '出票失敗，已部分退款成功，如有疑問請聯系客服。',
	chupiaoshibaituikuanshibai: '出票失敗，退款失敗，請聯系客服處理。',
	dingdanzhuangtaiyichang: '訂單狀態异常',
	shouxufei: '手續費',
	xinglixinxi: '行李資訊',
	xingli: '行李',
	dingdanxinxi: '訂單資訊',
	dingdantijiaochenggong: '訂單提交成功',
	qingzhifu: '請在30分鐘內付款，否則訂單將被取消。',
	kezailiebiaochakan: '您可以在訂單清單中查看我的“訂單”',
	chakandingdan: '查看訂單',
	ri: '日',
	yiyue: '一月',
	eryue: '二月',
	sanyue: '三月',
	siyue: '四月',
	wuyue: '五月',
	liuyue: '六月',
	qiyue: '七月',
	bayue: '八月',
	jiuyue: '九月',
	shiyue: '十月',
	shiyiyue: '十一月',
	shieryue: '十二月',
	xuanzefukuanfangshi: '選擇付款方式',
	qingyu: '請於',
	neiwanchengzhifu: '前完成付款',
	kaxinxi: '卡資訊',
	xinyongkahao: '卡號',
	xinyongkayouxiaoqi: '有效期',
	chikarenxingshi: '持卡人姓氏',
	chikarenmingzi: '持卡人名字',
	youxiang: '邮箱',
	dianhua: '電話',
	shengfendiqu: '省份/地區',
	chengshi: '城市',
	youbian: '郵編',
	jiedaodizhi: '街道地址',
	dingdanbianhao: '訂單編號:',
	dingdanbizhong: '訂單幣種:',
	dingdanjine: '訂單金額:',
	guojia: '國家',
	zhuan: '轉',
	ci: '次',
	fen: '分',
	miao: '秒',
};
